/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const InOrAboveLoad = ({
    inOrAboveLoad,
}: Partial<{
    inOrAboveLoad: string;
}>) =>
    inOrAboveLoad ? (
        <Row>
            <ValueCell
                single
                label="In Or Above Load"
                value={inOrAboveLoad === 'above-load' ? 'Above Load' : 'In Load'}
            />
        </Row>
    ) : (
        <></>
    );

export default InOrAboveLoad;
